import React, { useState } from "react";
import OrdersBarChart from "./ordersCharts/ordersOverTime";
import OrderDistributionPieChart from "./ordersCharts/orderDistrubtionPieChart";
import { useQuery } from "react-query";
import { getOrders } from "../../MyApi/orders";
import DataTable from "../UI/table/DataTable";

import TableActions from "../UI/table/TableActions";
import { formatPrice } from "../../utils/formatPrice";
import StatusBadge from "../orders/show/statusbadge";
import SkeletonWrapper from "../UI/skeletonWrapper";

const OrdersReportsTab = ({ statsWidget, isLoading }) => {
  const [currentPage ,setCurrentPage]=useState(1)
  const {data ,isLoading:ordersLoading ,isFetching ,refetch, error}=useQuery("getOrders", ()=>getOrders("","",currentPage))
  const orders =data?.data?.orders || []

  const ordersColumns = [
    { label: "معرف الطلب", render:(row)=> <div className="text-green"> {row.id} </div> },
    { label: "المتجر", accessor: "store.name" },
    { label: "العميل", accessor: "user.name" },
    {
      label: "المبلغ المستحق",
      render: (row) => (
        <div>
          {" "}
          {formatPrice(row.pricing.currency_factor, row.pricing.final_amount)}
        </div>
      ),
    },

    { label: "السائق", accessor: "courier.name" },
    {
      label: "الحالة",
      render: (row) => <StatusBadge status={row?.status?.value} />,
    },
    { label: "التاريخ   ", accessor: "created_at" },
    {
      label: "الإجراءات",
      render: (row) => (
        <TableActions
     show={`${process.env.PUBLIC_URL}/orders/${row.id}`}

          viewPermission={"view_order"}
        />
      ),
    },
  ];
  return (
    <div>
      <SkeletonWrapper isLoading={isLoading}>
        <div className="col-12">
          <OrdersBarChart data={statsWidget?.charts?.order_over_time}  barColor="#00C9A7" dataKeyX="date" dataKeyY="value" title={"الطلبات علي مدار الوقت"} name="عدد الطلبات"/>
        </div>
      </SkeletonWrapper>

      <div className="row">
        <div className="col-md-6">
          <SkeletonWrapper isLoading={isLoading}>
            <OrderDistributionPieChart data={statsWidget?.charts?.order_status_distribution ||[ ]} />
          </SkeletonWrapper>
        </div>
        <div className="col-md-6">
          <SkeletonWrapper isLoading={isLoading}>
            <OrdersBarChart data={statsWidget?.charts?.top_stores_by_orders} name="عدد الطلبات"  barColor="#FFCC03"   dataKeyX="name" dataKeyY="order_count" title={"أفضل 5 متاجر حسب الطلبات"}/>
          </SkeletonWrapper>
        </div>
        {/* <div className="col-md-4">
          <SkeletonWrapper isLoading={isLoading}>
            <OrdersBarChart   data={statsWidget?.charts?.delivery_time_trend}   barColor="#FFCC03"    title={"اتجاه متوسط ​​وقت التسليم"}/>
          </SkeletonWrapper>
        </div> */}
      </div>
      <SkeletonWrapper isLoading={isLoading}>
        <DataTable
          columns={ordersColumns}
          data={orders || []}
          title="الطلبات"
          totalItems={data?.data?.pagination?.total || 0}
          itemsPerPage={data?.data?.pagination.last_page}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
           isLoading={ordersLoading}
           isFetching={isFetching}
           error={error}
           onRetry={() => refetch()}
        />
      </SkeletonWrapper>

    </div>
  );
};

export default OrdersReportsTab;
